import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const removeRole = async (payload: { userId: string; roleName: string }) => {
	const response = await cmsClient.post("/roles/remove/", {
		user_id: payload.userId,
		role_name: payload.roleName
	});
	return response.data;
};

const useRemoveRole = (userId: string) => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Role removed" />, {
			hideProgressBar: true
		});
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["user-roles", userId]);
	};

	const onError = (error: unknown) => {
		const detail = (error as { response?: { data?: Record<string, unknown> } })
			?.response?.data;
		const message =
			(detail as { detail?: string })?.detail ??
			(detail ? Object.values(detail).flat().join(" ") : undefined) ??
			"Something went wrong, try again";

		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const mutation = useMutation(removeRole, {
		onError,
		onSuccess,
		onSettled
	});

	return mutation;
};

export default useRemoveRole;
